<template>
  <el-select
    v-model="selectedRecord"
    :remote-method="loadRecords"
    :loading="loading"
    :placeholder="placeholder"
    class="select-info flex-grow-1"
    filterable
    clearable
    remote
    reserve-keyword
    @input="$emit('input', $event)"
  >
    <el-option
      v-for="record in records"
      :key="record.id"
      :label="getLabel(record)"
      :value="record.id"
      class="select-info"
    >
      <span style="float: left"
        >{{ record.lastName }} {{ record.firstName }}</span
      >
      <span style="float: right; color: #8492a6; font-size: 13px">{{
        record.institutionName
      }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: ['value', 'placeholder'],
  data() {
    return {
      loading: false,
      selectedRecord: {},
      records: [],
    };
  },
  methods: {
    getLabel(record) {
      let label = '';
      if (record.lastName) {
        label += `${record.lastName} `;
      }
      if (record.firstName) {
        label += `${record.firstName} `;
      }
      if (record.institutionName) {
        label += `(${record.institutionName})`;
      }
      return label;
    },
    loadRecords(query) {
      if (query !== '') {
        this.loading = true;
        this.$http
          .get(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/search/persons?searchTerm=${query}&page=0&size=50`,
          )
          .then(response => {
            this.loading = false;
            this.records = response.data._embedded.personEntities;
          });
      } else {
        this.records = [];
      }
    },
  },
};
</script>

<style scoped></style>
